import { AutogenModelEdiTransSet, AutogenRowEdiTransSet } from "./autogen/AutogenModelEdiTransSet";

export class ModelEdiTransSet extends AutogenModelEdiTransSet<RowEdiTransSet> {
	constructor() {
		super(RowEdiTransSet);
	}
}

export class RowEdiTransSet extends AutogenRowEdiTransSet {
}